// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"225":"layout","400":"faceset","826":"index"}[chunkId] || chunkId) + "-1778733020780.css";
};